import Model from "../Model";

class MapDataVideowallCompany extends Model{

    buildUrl ({ param }) {
        return ['/videowallcompany/region', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new MapDataVideowallCompany;